import React from 'react';
import branding from '../../branding.json';

export const SciFiBackground: React.FC = () => {
  // Check if background settings exist and are enabled
  if (!branding.theme?.background?.enabled) {
    return null;
  }
  
  // Get background settings from branding or use defaults
  const gridColor = branding.theme.background.gridColor ?? 'rgba(59, 130, 246, 0.3)';
  const gridSize = branding.theme.background.gridSize ?? 40;
  
  return (
    <>
      {/* Grid background */}
      <div 
        className="fixed inset-0 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(to right, ${gridColor} 1px, transparent 1px),
            linear-gradient(to bottom, ${gridColor} 1px, transparent 1px)
          `,
          backgroundSize: `${gridSize}px ${gridSize}px`,
          zIndex: 1
        }}
      />
      
      {/* Diagonal lines */}
      <div 
        className="fixed inset-0 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(45deg, ${gridColor} 1px, transparent 1px),
            linear-gradient(135deg, ${gridColor} 1px, transparent 1px)
          `,
          backgroundSize: `${gridSize * 2}px ${gridSize * 2}px`,
          zIndex: 1
        }}
      />
      
      {/* Glowing points at intersections */}
      <div 
        className="fixed inset-0 pointer-events-none"
        style={{
          backgroundImage: `radial-gradient(circle, ${gridColor} 1px, transparent 1px)`,
          backgroundSize: `${gridSize}px ${gridSize}px`,
          backgroundPosition: `${gridSize / 2}px ${gridSize / 2}px`,
          zIndex: 1
        }}
      />
    </>
  );
};
